// src/components/SettingRow.tsx
import React from "react";
import { Grid, Tooltip } from "@mui/material";

interface SettingRowProps {
  title: React.ReactNode;
  children: React.ReactNode;
  tooltip?: string; // optional tooltip text
}

/**
 * SettingRow: simple 2-column row for settings pages.
 * - left column (xs=4): label (with optional tooltip)
 * - right column (xs=8): control area
 */
const SettingRow: React.FC<SettingRowProps> = ({ title, children, tooltip }) => {
  const label = tooltip ? (
    <Tooltip title={tooltip} placement="bottom-end" arrow>
      <span style={{ display: "inline-flex", alignItems: "center" }}>{title}</span>
    </Tooltip>
  ) : (
    title
  );

  return (
    <Grid container alignItems="center" spacing={2} sx={{ mb: 2 }}>
      <Grid
        item
        xs={4}
        sx={{
          fontWeight: "normal",
          display: "flex",
          alignItems: "center",
        }}
      >
        {label}
      </Grid>

      <Grid item xs={8}>
        {children}
      </Grid>
    </Grid>
  );
};

export default SettingRow;
